
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'
import { initData } from "./initData"

const PageConst= {
  ACTION: {
    init: { api: 'T1110StudentCurriculumService.C20201_init' },
    doSave: { api: 'T1110StudentCurriculumService.doSave' },
    getEdit: { api: 'T1110StudentCurriculumService.getEdit' },
    doRead: { api: 'T1110StudentCurriculumService.doRead' },
    doDelete: { api: 'T1110StudentCurriculumService.doDelete' },
    doBrowse: { api: 'T1110StudentCurriculumService.doBrowse' },
    // getTableColumnDefsDataForSearchTable: { api: 'T1110StudentCurriculumService.getTableColumnDefsDataForSearchTable' },
    // getTableColumnDefsDataForAtForm: { api: 'T1110StudentCurriculumService.getTableColumnDefsDataForAtForm' },
  },
}

const module = {
  state: {
    PageConst,
    students: [],
    centers:[],
    users:[],
    curriculumAdvisors:[],
    curriculumSalesPerson: [],

    oldRow: null,
    leaveButtonClicked: false,
    dropdownList:{
      contract_status: [
        { value: 1, color: "#2196F3", label: '契約' },
        { value: 2, color: "#F2AA84", label: '保留中' },
        { value: 3, color: "#C00000", label: '拒否' },
        { value: 4, color: "#7030A0", label: '契約キャンセル' },
        { value: 5, color: "#002060", label: 'クーリングオフ' },
        { value: 0, color: "#82D973", label: '下書き' },
      ],
      enrollment_status: [
        { value: 0, label: '登録なし' },
        { value: 1, label: '在籍中' },
        { value: 2, label: '休会中' },
        { value: 3, label: '退会' }
      ],
      studentInfo:{
        // "性別"
        instructorGender: [
          "男",
          "女",
          "未設定"
        ],
        // "保護者続柄"
        "guardianRelationship": [
          "父",
          "母",
          "祖父",
          "祖母",
          "叔母",
          "叔父"
        ],
        // "学年（区分）"
        academicType: [
          "小学",
          "中学",
          "高校",
          "既卒",
          "社会人",
          "大学",
          "専門",
          "幼児"
        ],
        // "学年（年生）"
        academicYear: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "年少",
          "年中",
          "年長",
          "-"
        ],
        academicYearCustom:{
          幼児: ["年少","年中","年長",],
          小学: ["1","2","3","4","5","6"],
          中学: ["1","2","3",],
          高校: ["1","2","3",],
          既卒: ["1","2","3","4"],
          大学: ["1","2","3","4"],
          専門: ["1","2","3","4"],
          社会人: ["-"],
        },
        // "分類"
        schoolCategory: [
          "私立",
          "国立",
          "都立",
          "道立",
          "府立",
          "県立",
          "市立",
          "町立",
          "村立",
          "その他",
        ],
        // "学期制"
        semester: [
          "２学期制",
          "３学期制",
          "-",
          "不明"
        ],
        // "住所"
        address1: [
          "北海道",
          "青森県",
          "岩手県",
          "宮城県",
          "秋田県",
          "山形県",
          "福島県",
          "茨城県",
          "栃木県",
          "群馬県",
          "埼玉県",
          "千葉県",
          "東京都",
          "神奈川県",
          "新潟県",
          "富山県",
          "石川県",
          "福井県",
          "山梨県",
          "長野県",
          "岐阜県",
          "静岡県",
          "愛知県",
          "三重県",
          "滋賀県",
          "京都府",
          "大阪府",
          "兵庫県",
          "奈良県",
          "和歌山県",
          "鳥取県",
          "島根県",
          "岡山県",
          "広島県",
          "山口県",
          "徳島県",
          "香川県",
          "愛媛県",
          "高知県",
          "福岡県",
          "佐賀県",
          "長崎県",
          "熊本県",
          "大分県",
          "宮崎県",
          "鹿児島県",
          "沖縄県"
        ],
        // "営業担当"
        salesRepresentativeName: [
          "浅井",
          "神宮寺",
          "上田",
          "藤原",
          "福井"
        ]
      },
      background:{
      // 入会を決定した方
        whoDecideToJoin:[
          "父",
          "母",
          "祖父",
          "祖母",
          "叔母",
          "叔父",
          "本人",
        ]
      },
      rowExperienceParticipants:{
        participant:[
          "父",
          "母",
          "祖父",
          "祖母",
          "叔母",
          "叔父",
          "本人",
        ]
      },
      registrationInfo:{
        // "受講時間"
        courseInfo1: [
          "40分前半",
          "40分後半",
          "90分"
        ],
        // "スタイル"
        courseInfo2: [
          "1対１",
          "1対２"
        ],
        // "ﾍﾞｰｼｯｸ/ｱﾄﾞﾊﾞﾝｽ"
        courseInfo3: [
          "",
          "ベーシック",
          "アドバンス",
          "中受",
          "海外"
        ],
        // "コース"
        courseInfo4: [
          "スタンダード",
          "オープン",
          "プライム"
        ],
        // "曜日"
        dayOfWeek: [
          "月",
          "火",
          "水",
          "木",
          "金",
          "土",
          "日"
        ],
        // "開始時間"
        startTime: [
          "14:50",
          "15:40(90不可)",
          "16:40",
          "17:30(90不可)",
          "18:20",
          "19:10(90不可)",
          "20:00",
          "20:50(90不可)",
          "22:00(特)",
          "23:40(特)",
          "1:20(特)",
          "3:00(特)",
          "4:40(特)",
          "6:20(特)",
          "9:00(特)",
          "10:40(特)",
          "13:10(特)"
        ],
      },
      interestSchoolInfo:{
        classification:[
          "私立",
          "国立",
          "都立",
          "道立",
          "府立",
          "県立",
          "市立",
          "町立",
          "村立",
          "その他",
        ],
        desire:[
          "高いと分かるが希望",
          "できるだけ",
          "最低これ以上",
        ]
      },
      lessonEnvironment:{
        // "使用機材"
        equipment: [
          "iPad",
          "Androidタブレット",
          "WindowsPC(据置)",
          "Mac(据置)",
          "WindowsPC(ノート)",
          "Mac(ノート)"
        ],
      },
      subject:{
        textbooks:{
          // "所有状況"
          status:[
            "後日決定(プリント送付)",
            "生徒既に所有"
          ]
        }
      },
      "テスト/内申": [
        "テスト",
        "内申"
      ],
      "学年（区分）": [
        "小学",
        "中学",
        "高校"
      ]
    },

    HighlightMessageStyle: {
      sectionTitleWidth: 0,
    },
  },

  getters: {

  },

  mutations: {
  },
  actions: {
    init ({ commit, state }, payload = {}) {
      ApiUtils.postData({
        data: [{ api: PageConst.ACTION.init.api, input: payload }]
      }).then((res) => {
        const data = res[0].output;
        commit('setState', {
          students: data.students,
          centers: data.centers,
          users: data.users,
          curriculumAdvisors: data.curriculumAdvisors,
          curriculumSalesPerson: data.curriculumSalesPerson,
        })
      })
    },
    doSave ({ commit, state, dispatch }, payload) {
      ApiUtils.postData({
        data: [{ api: PageConst.ACTION.doSave.api, input: payload }]
      }).then(async(res) => {
        await dispatch('getEdit', {
          id: res[0].output.id,
          highlight_message_schedule_no: window.vue.$route.query.highlight_message_schedule_no ?? undefined
        });
      })
    },
    async getAdd ({ commit, state, rootGetters }, payload) {
      const data = await ApiUtils.postData({
        data: {
          defaultReferenceDate: { api: 'T1130StudentSeminarService.getDefaultReferenceDate', input: {} }
        }
      })
      const dt = data.defaultReferenceDate.output;
      const defaultData = ObjArrUtils.merge({}, initData, {
        row: {
          reference_start_date: dt.reference_start_date,
          reference_end_date: dt.reference_end_date,
          _original_contract_status: null,
          contract_status: rootGetters['Auth/getUser']?.user_type_code === 520 ? 0 : 1,
          salesperson_user_no: rootGetters['Auth/getUser']?.user_type_code === 520 ? rootGetters['Auth/getUser']?.user_no : undefined,
        }
      });
      commit('SET_ROW',defaultData);
      commit('setState',{
        oldRow: defaultData,
        _removeReactivity: true,
      })
    },
    async getEdit ({ commit, state, dispatch }, payload) {
      const data = await ApiUtils.postData({
        data: [{
          api: PageConst.ACTION.getEdit.api,
          input: payload
        }]
      }).catch(e => {
        console.error('getEdit error', e)
      })
      const dt = data[0].output;
      const row = JSON.parse(dt.json_text);
      delete dt.json_text;
      row.row = dt;
      row.row._original_contract_status = row.row.contract_status;
      const rtnRow = ObjArrUtils.merge(initData,row);
      commit('SET_ROW', rtnRow);
      commit('setState', {
        _removeReactivity: true,
        oldRow: rtnRow
      });

      // Update URL curriculum_id (only if curriculum_id changed)
      if (window.vue.$route.params.curriculum_id !== (row.row.id).toString()) {
        window.vue.$router.push({name: window.vue.$route.name, params:{curriculum_id: row.row.id}, query: window.vue.$route.query ?? {}});
      }
    },
    async getT1130Count({ state }, studentNo) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T1130StudentSeminarService.getT1130Count',
            input: { student_no: studentNo ?? 0 }
          },
        ]
      }).then(res => res[0].output)
    },
    async C20201_getMemo({ state }, payload) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T1140StudentCurriculumMemoService.C20201_getMemo',
            input: payload
          },
        ]
      }).then(res => res[0].output)
    },
    async C20201_addMemo({ state }, payload) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T1140StudentCurriculumMemoService.C20201_addMemo',
            input: payload
          },
        ]
      }).then(res => res[0].output)
    },
    async C20201_updateMemo({ state }, payload) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T1140StudentCurriculumMemoService.C20201_updateMemo',
            input: payload
          },
        ]
      }).then(res => res[0].output)
    },
    async C20201_deleteMemo({ state }, payload) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T1140StudentCurriculumMemoService.C20201_deleteMemo',
            input: payload
          },
        ]
      }).then(res => res[0].output)
    },

  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
